import { frontendserverurl } from './../../../../environments/environment.development';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppdataService } from '../../../service/appdata.service';
import { NewandeditagentComponent } from '../newandeditagent/newandeditagent.component';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-agents',
  standalone: false,
  templateUrl: './agents.component.html',
  styleUrl: './agents.component.scss'
})
export class AgentsComponent {
  agents: any[] = [];
  frontendserverurl = frontendserverurl;

  agentForm: any;
  constructor(
    private dialog: MatDialog,
    private appData: AppdataService
  ) {
    appData.agents.subscribe({
      next: (data) => {
        this.agents = data;
      }
    });

  }

  async newAgent() {
    let dia = await this.dialog.open(NewandeditagentComponent, {
      data: {
        agent: null
      }
    });
    dia.afterClosed().subscribe({
      next: (data) => {
        if (data === true) {
          this.appData.loadAllAgents();
        }
      }
    });
  }

  async editAgent(agent: any) {
    let dia = await this.dialog.open(NewandeditagentComponent, {
      data: {
        agent
      }
    });
    dia.afterClosed().subscribe({
      next: (data) => {
        if (data === true) {
          this.appData.loadAllAgents();
        }
      }
    });
  }

}
